import React from "react";

interface UserAvatarProps {
  name: string;
}

export const UserAvatar: React.FC<UserAvatarProps> = ({ name }) => {
  const getInitials = (nameStr: string) => {
    if (!nameStr || nameStr === "N/A") return "?";
    return nameStr
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const getAvatarBg = (nameStr: string) => {
    const colors = [
      "bg-blue-100 text-blue-800 border-blue-200",
      "bg-emerald-100 text-emerald-800 border-emerald-200",
      "bg-indigo-100 text-indigo-800 border-indigo-200",
      "bg-purple-100 text-purple-800 border-purple-200",
      "bg-pink-100 text-pink-800 border-pink-200",
      "bg-amber-100 text-amber-800 border-amber-200",
      "bg-teal-100 text-teal-800 border-teal-200",
    ];
    let hash = 0;
    for (let i = 0; i < nameStr.length; i++) {
      hash = nameStr.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  return (
    <div className={`w-10 h-10 rounded-full border flex items-center justify-center text-sm font-bold shadow-sm select-none ${getAvatarBg(name)}`}>
      {getInitials(name)}
    </div>
  );
};
